import {
  Box,
  Button, ClickAwayListener,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent, styled, Tooltip,
  Typography
} from '@mui/material';
import React, {useContext, useState} from 'react';
import {AppContext} from '@/utils/appContext';
import {useTranslation} from 'react-i18next';
import {makeStyles} from 'tss-react/mui';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {ISearchForm} from '@/interfaces/bookingContext';
import {website} from '@/utils/helpers';
import {InfoCircle, Trash} from "@vectopus/atlas-icons-react";
import {tooltipClasses, TooltipProps} from "@mui/material/Tooltip";
import {useResponsive} from "@/hooks/use-responsive";

export const ModalGuests = (props: any) => {
  const {classes} = useStyles();
  const appContext = useContext(AppContext);
  const {t} = useTranslation();
  const [age, setAge] = useState<string>('');

  const upSm = useResponsive('up', 'sm');
  const downSm = useResponsive('down', 'sm');
  const downMd = useResponsive('down', 'md');
  const upMd = useResponsive('up', 'md');

  const handleChange = (event: SelectChangeEvent, i: number, indexValue: number) => {
    setAge(event.target.value);
    appContext.setUpdateSearch(true);
    appContext.searchForms[i].ageOfChildren.splice(indexValue, 1, Number(event.target.value));
    appContext.setSearchForms([...appContext.searchForms]);
  };

  const [openTooltip, setOpenTooltip] = React.useState(false);

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  };

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#000',
      color: '#fff',
      maxWidth: 350,
      borderRadius: 0,
      fontSize: 12,
      lineHeight: '16px',
      fontFamily: theme.typography.body1.fontFamily,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        lineHeight: '18px',
        left: 25,
        maxWidth: '85%',
      }
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#000',
      right: '0!important',
    },
  }));

  return (
    <>
      <Box sx={{height: '100%', overflow: 'scroll!important'}}>
        <Grid
            container
            alignItems={'center'}
            justifyContent={'space-evenly'}
            direction={'row'}
            p={2}
            sx={{borderBottom: '1px solid #F4F3EF', position: 'relative'}}>
          {
              (props.params.container === 'DrawerSearchWidget' || downMd) && (
                  <Box sx={{position: 'absolute', left: 0, cursor: 'pointer'}} p={3} pl={4}>
                    <ArrowBackIcon onClick={() => props.params.handleCloseGuestsModal()}/>
                  </Box>
              )
          }
          <Grid item xs={12} textAlign={'center'}>
            <Typography variant={'h4'} component={'h4'}>
              {t('guests')}
            </Typography>
          </Grid>
        </Grid>

        <Box p={3} pr={4} pl={4} sx={{ paddingBottom: {xs: '150px', sm: '50px'}  }}>

          <Typography variant={'h5'} component={'h4'}>
            {t('con_chi_viaggi?')}
          </Typography>

          <Typography variant={'body2'} component={'p'} pb={2} mt={1} sx={{ lineHeight: '18px' }}>
            {t('con_chi_viaggi_desc')}
          </Typography>

          {appContext.searchForms.map((form: ISearchForm, index: number) => (
            <Box key={index} mt={3}>
              <Typography variant={'h5'} component={'h4'} pb={2} className={classes.borderTitle} style={{textTransform: "capitalize"}}>
                {t('accommodation')} {index + 1}
              </Typography>

              {index > 0 ? (
                <Box
                  sx={{verticalAlign: 'sub', fontSize: 16, marginLeft: '20px', color: 'red', display: 'initial', cursor: 'pointer'}}
                  onClick={() => props.params.removeSearchForm(index)}
                >
                  <Trash size={24}  />
                </Box>
              ) : (
                ''
              )}

              {/*{
                form.ageOfChildren.length > 0 && form.ageOfChildren.includes(-1) && (
                  <Box p={1} className={classes.warningBox} mt={2}>
                    <Typography variant={'body1'} component={'p'}>
                      {t('indicare_eta_bambino')}
                    </Typography>
                  </Box>
                )
              }*/}

              <Box mt={2} mb={3}>
                {
                  form.NoOfAdults + form.ageOfChildren.length > 8 && website.code !== 'EV' && (
                    <Box p={1} mb={2} className={classes.warningBox}>
                      <Typography variant={'body1'} component={'p'}>
                        {t('No_8_more_guests')}
                      </Typography>
                    </Box>
                  )
                }

                {
                  form.NoOfAdults + form.ageOfChildren.length > 6 && website.code === 'EV' && (
                    <Box p={1} mb={2} className={classes.warningBox}>
                      <Typography variant={'body1'} component={'p'}>
                        {t('No_6_more_guests')}
                      </Typography>
                    </Box>
                  )
                }

                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  pb={3}>
                  <Grid item xs={6}>
                    <Typography variant={'h5'} component={'h5'}>
                      {t('adults')}
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={classes.guestsController}>
                    <Typography variant={'body1'} component={'div'} style={{textAlign: 'right'}}>
                      <i
                        className="las la-minus-square"
                        onClick={() => {
                          appContext.setUpdateSearch(true);
                          props.params.setQuantity('NoOfAdults', false, index);
                        }}></i>{' '}
                      <Box>{appContext.searchForms[index].NoOfAdults}</Box>
                      <i
                        className="las la-plus-square"
                        onClick={() => {
                          appContext.setUpdateSearch(true);
                          props.params.setQuantity('NoOfAdults', true, index);
                        }}></i>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  pb={3}
                  pt={0}>
                  <Grid item xs={6}>
                    <Box display={'flex'} alignItems={'center'}>
                      <Typography variant={'h5'} component={'h5'} pr={1}>
                        {t('children')}
                      </Typography>
                      {
                        upSm && (
                          <HtmlTooltip arrow title={t('tooltip_kids')} placement="bottom">
                            <Button sx={{ minWidth: 'auto' }}><InfoCircle size={14} color={'#205fa4'} /></Button>
                          </HtmlTooltip>
                        )
                      }
                      {
                        downSm && (
                          <ClickAwayListener onClickAway={handleTooltipClose}>
                            <div>
                              <HtmlTooltip
                                PopperProps={{
                                  disablePortal: true,
                                }}
                                onClose={handleTooltipClose}
                                open={openTooltip}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                arrow
                                title={t('info_pet')}
                                placement="bottom"
                              >
                                <Button sx={{ minWidth: 'auto' }} onClick={handleTooltipOpen}><InfoCircle size={16} color={'#205fa4'} /></Button>
                              </HtmlTooltip>
                            </div>
                          </ClickAwayListener>
                        )
                      }
                    </Box>
                    <Typography variant={'body2'} component={'p'} sx={{fontSize: 14}}>
                      (0-17 {t('years')})
                    </Typography>
                  </Grid>

                  <Grid item xs={4} className={classes.guestsController}>
                    <Typography variant={'body1'} component={'div'} style={{textAlign: 'right'}}>
                      <i
                        className="las la-minus-square"
                        onClick={() => {
                          appContext.setUpdateSearch(true);
                          props.params.setQuantity('Children', false, index);
                        }}></i>
                      <Box>{form.ageOfChildren?.length}</Box>
                      <i
                        className="las la-plus-square"
                        onClick={() => {
                          appContext.setUpdateSearch(true);
                          props.params.setQuantity('Children', true, index);
                        }}></i>
                    </Typography>
                  </Grid>
                </Grid>

                {form.ageOfChildren?.length > 0 && (
                  <Box mb={3}>
                    <Typography variant={'body1'} component={'b'}>
                      {t('eta_bambino')}
                    </Typography>
                    <Typography variant={'body2'} component={'p'}>
                      {t('indicare_eta_bambino_desc')}
                    </Typography>
                    <Grid
                      container
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                      spacing={2}
                      mt={1}>
                      {[...Array(form.ageOfChildren.length)].map((e, i) => (
                        <Grid item xs={6} key={i}>
                          <FormControl className={ (form.ageOfChildren.length > 0 && form.ageOfChildren.includes(-1)) ? classes.ageSelectFieldsError : classes.ageSelectFields }>
                            <InputLabel
                              id="demo-simple-select-label"
                              sx={{backgroundColor: '#FFF'}}>
                              {t('select_age')}
                            </InputLabel>
                            <Select
                              value={String(form.ageOfChildren[i])}
                              defaultValue={'-1'}
                              label={t('select_age')}
                              MenuProps={{disablePortal: true}}
                              onChange={(e: SelectChangeEvent) => handleChange(e, index, i)}>
                              <MenuItem value={'-1'} key={'-1'}>
                                {t('select_age')}
                              </MenuItem>
                              {[...Array(18)].map((v, i) => (
                                <MenuItem value={i.toString()} key={i}>
                                  {i} {t('years')}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}

                {
                  website.code !== 'VP' && (
                    <>
                      {
                        (appContext.searchForms[index]?.property !== 'PT' && appContext.searchForms[index]?.property !== 'UL' && appContext.searchForms[index]?.property !== 'CI' && appContext.searchForms[index]?.property !== 'BI') ? (
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            pb={3}
                            pt={0}>
                            <Grid item xs md={6}>
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant={'h5'} component={'h5'} pr={1}>
                                  {t('icon_animali')}
                                </Typography>
                                {
                                  upSm && (
                                    <HtmlTooltip arrow title={t('info_pet')} placement="bottom">
                                      <Button sx={{ minWidth: 'auto' }}><InfoCircle size={14} color={'#205fa4'} /></Button>
                                    </HtmlTooltip>
                                  )
                                }
                                {
                                  downSm && (
                                    <ClickAwayListener onClickAway={handleTooltipClose}>
                                      <div>
                                        <HtmlTooltip
                                          PopperProps={{
                                            disablePortal: true,
                                          }}
                                          onClose={handleTooltipClose}
                                          open={openTooltip}
                                          disableFocusListener
                                          disableHoverListener
                                          disableTouchListener
                                          arrow
                                          title={t('info_pet')}
                                          placement="bottom"
                                        >
                                          <Button sx={{ minWidth: 'auto' }} onClick={handleTooltipOpen}><InfoCircle size={16} color={'#205fa4'} /></Button>
                                        </HtmlTooltip>
                                      </div>
                                    </ClickAwayListener>
                                  )
                                }
                              </Box>

                              <Typography variant={'body2'} component={'p'} sx={{fontSize: 14}}>
                                ({t('costi_aggiuntivi_pulizia')})
                              </Typography>
                            </Grid>

                            <Grid item xs={4} className={classes.guestsController} style={{paddingTop: 0}}>
                              <Typography variant={'body1'} component={'div'} style={{textAlign: 'right'}}>
                                <i
                                  className="las la-minus-square"
                                  onClick={() => {
                                    appContext.setUpdateSearch(true);
                                    props.params.setPets(false, index);
                                  }}></i>
                                <Box>{appContext.searchForms[index].Pets}</Box>
                                <i
                                  className="las la-plus-square"
                                  onClick={() => {
                                    appContext.setUpdateSearch(true);
                                    props.params.setPets(true, index);
                                  }}></i>
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : (
                          <Typography variant={'body2'} component={'span'}>{t('no_pets_allowed_single_property')}</Typography>
                        )
                      }

                      {
                        appContext.searchForms[index].Pets > 0 && !appContext.searchForms[index]?.property && (
                          <Box mb={2}>
                            <Typography variant={'body2'} component={'span'} sx={{ color: '#B32D24' }} dangerouslySetInnerHTML={{ __html: t('no_pets_allowed_generic_destination') }} />
                          </Box>
                        )
                      }
                    </>
                  )
                }

              </Box>
            </Box>
          ))}

          {
           appContext.searchForms.length < 3 && website.code !== 'VP' && (
              <Box pb={2} className={classes.addAccommodationBtn}>
                <Button
                  color={'primary'}
                  variant={'text'}
                  onClick={() => props.params.addSearchForm()}>
                  <i className="las la-plus-square" style={{ fontSize: 24 }}></i>
                  {t('add_accommodation')}
                </Button>
              </Box>
            )
          }

          {
            upSm && props.params.container !== 'DrawerSearchWidget' && props.params.container !== 'SearchBarMobile' && (
              <Grid container direction={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                <Grid item xs={12}>
                  <Box className={classes.confirm}>
                    <Button
                      color={'primary'}
                      variant={website.code === 'VP' ? 'containedSecondaryVP' : 'contained'}
                      onClick={() => props.params.handlePopoverClose()}>
                      {t('Conferma')}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            )
          }

          {
              upSm && props.params.container === 'SearchBarMobile' && (
                  <Grid container direction={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                    <Grid item xs={12}>
                      <Box className={classes.confirm}>
                        <Button
                            color={'primary'}
                            variant={website.code === 'VP' ? 'containedSecondaryVP' : 'contained'}
                            onClick={() => props.params.handleCloseGuestsModal()}>
                          {t('Conferma')}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
              )
          }

          {
            upSm && props.params.container === 'DrawerSearchWidget' && (
              <Grid container direction={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                <Grid item xs={12}>
                  <Box className={classes.confirm}>
                    <Button
                      color={'primary'}
                      variant={website.code === 'VP' ? 'containedSecondaryVP' : 'contained'}
                      onClick={() => props.params.handleCloseGuestsModal()}>
                      {t('Conferma')}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            )
          }
        </Box>
      </Box>

      {
        downSm && (
          <Paper elevation={2} className={classes.confirmBtn}>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => props.params.handleCloseGuestsModal()}>
              {t('Conferma')}
            </Button>
          </Paper>
        )
      }
    </>
  );
};

const useStyles = makeStyles()((theme) => {
  return {
    confirmBtn: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      padding: '20px 32px',
      boxShadow: '0 -3px 10px #00000029',
      fontFamily: theme.typography.h6.fontFamily,
      '.MuiButton-root': {
        width: '100%',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: 0,
        fontSize: 20,
        border: 0,
        '&:hover': {
          backgroundColor: 'black',
          color: 'white',
          borderColor: 'black'
        }
      }
    },
    guestsController: {
      '.MuiTypography-root': {
        display: 'flex',
        justifyContent: 'end',
        i: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 26,
          padding: '0 2px',
          cursor: 'pointer'
        },
        '.MuiBox-root': {
          margin: '0 10px',
          display: 'flex',
          alignItems: 'center',
          fontSize: 18,
          fontWeight: 'bold',
          minWidth: 15
        }
      }
    },
    warningBox: {
      backgroundColor: '#b32d24',
      color: '#FFF'
    },
    borderTitle: {
      borderBottom: '4px solid' + theme.palette.secondary.main,
      display: 'inline-block',
      paddingBottom: 0
    },
    confirm: {
      float: 'right',
      '.MuiButton-root': {
        textTransform: 'uppercase',
        padding: '10px 40px',
        width: '100%',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: theme.radius.formBorderRadius,
        fontSize: 16,
        border: '1px solid black',
        '&:hover': {
          backgroundColor: 'white',
          color: 'black',
          border: '1px solid black'
        }
      }
    },
    addAccommodationBtn: {
      float: 'right',
      '.MuiButton-root': {
        width: '100%',
        backgroundColor: 'white',
        color: 'black',
        fontSize: 16,
        '&:hover': {
          backgroundColor: 'white',
        }
      }
    },
    ageSelectFields: {
      '.MuiOutlinedInput-notchedOutline': {
        borderRadius: '0!important',
        borderColor: 'black'
      },
      '& label': {
        '&.Mui-focused': {
          color: '#000',
        }
      }
    },
    ageSelectFieldsError: {
      '& label': {
        color: '#B32D24!important',
      },
      '.MuiInputBase-formControl': {
        borderColor: '#B32D24'
      }
    },
    pb: {
      paddingBottom: 200
    }
  };
});
